import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
class BulkOperationRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildQuery(fields) {
    return gql`
            query GetBulkOperationResult($filter: BulkOperationFilterInput!) {
                getBulkOperationResult(filter: $filter) {
                    id @include(if: ${fields.includes("id")})
                    status @include(if: ${fields.includes("status")})
                    items @include(if: ${this.getItemsQueryFields().some((f) => fields.includes(f))}) {
                        id @include(if: ${fields.includes("items.id")})
                        status @include(if: ${fields.includes("items.status")})
                        message @include(if: ${fields.includes("items.message")})
                    }
                    start_at @include(if: ${fields.includes("start_at.seconds")}) {
                        seconds
                    }
                    end_at @include(if: ${fields.includes("end_at.seconds")}) {
                        seconds
                    }
                    entity_type @include(if: ${fields.includes("entity_type")})
                    timeout @include(if: ${fields.includes("timeout")})
                    retries @include(if: ${fields.includes("retries")})
                }
            }
        `;
  }
  getGqlPageArgs(filter) {
    return this.buildFilter(filter);
  }
  buildFilter(filter) {
    return {
      filter: {
        id: filter.id
      }
    };
  }
  getItemsQueryFields() {
    return ["items.id", "items.status", "items.message"];
  }
}
export {
  BulkOperationRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
